module.exports = __webpack_public_path__ + "static/img/Dharma Favitri Hariyanto-close.798d315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Dharma Favitri Hariyanto-close.jpg
// module id = 8Q8H
// module chunks = 1